import { Card, LoadingSpinner, Modal, ButtonGroup, Icon, Tooltip } from 'pepsico-ds'
import React, { useEffect, useState, useRef } from 'react'
import { formatNumberWithCommas, handleDomToImgDownloadPdf } from '../../utils/utils'
// import SupplierModalFilters from './SupplierModalFilters'
import { Col, Row } from 'antd'
import CustomLineChart from '../Charts/ComanChart/CustomLineChart'
import SupplierPerfTable from '../Table/SupplierPerfTable'
import { spmDataMock } from '../../mocks/supplierPerformanceData'
import NoData from '../NoData/NoData'
import { localStoreKeys } from '../../constants/localStoreKeys';
import { useSelector, useDispatch } from "react-redux";
import { setKeyValue } from "../../redux/reducer/localDataSlice";
import { trackModalView, getModalAttributes } from '../../utils/fullstory-utils';
import CustomButtons from '../Cards/CustomButtons'
import { staticNotes } from '../../constants/staticNotes';
import FilterWithSuppliers from './FilterWithSuppliers';
import DropdownWithIcons from './DropdownWithIcons'
import { useToast } from '../../components/Toast/ToastContext';
import Vector from '../../assets/Vector.png'
import EDF_checked from "../../../src/assets/EDF_checked.svg";

function SupplierPerformanceModal({ openModal, setOpenModal, userData, selectedYear, capability, userDataLandingPage, landingPageFilters }) {
    const [loader, setLoader] = useState(true)
    const [spmData, setSpmData] = useState({})
    const [buttonGroupItems, setButtonGroupItems] = useState([])
    const feedbackFormUrl = useSelector((state) => state?.localData?.data[localStoreKeys.feedbackFormUrl]);
    const isLoading = useSelector((state) => state?.loader?.isLoading);
    const dispatch = useDispatch();
    const [dataLoadActionType, setDataLoadActionType] = useState("");

    const supplierPerformanceRef = useRef()

    const { showToast } = useToast();


    
    const checkPDFDownloaded = () => {}

    useEffect(() => {
        if (openModal) {
            trackModalView("Supplier Performance"+' '+capability, 'view');
        }
    }, [openModal, capability]);

    const handleClose = () => {
        trackModalView("Supplier Performance"+' '+capability, 'close');
        setDataLoadActionType(""); 
        dispatch(setKeyValue({ key: localStoreKeys.isSpmModalOpened, value: true }));
        setOpenModal(false);
    };
    
    const getSupplierPerformaceFilters = (value) => {
        setSpmData(value.data)
        setLoader(value.loader)
        setDataLoadActionType(value?.data?.type)

        const appList = value.data?.apps
        if (appList && appList.length > 0) {
            const tempbuttonGroupItems = appList
                ?.filter(item => item.isActive)
                .map(item => ({
                    label: item.app,
                    onClick: () => window.open(item.url, "_blank"),
                }));

            setButtonGroupItems(tempbuttonGroupItems)
        }
    }

    
    const getSPMValuePercentageColor = (value) => {
        if (value < 95 && value > 70) {
            return '#FFCC49'
        }
        if (value < 70) {
            return '#AA001A'
        }
        if (value >= 95) {
            return '#006A42'
        }
    }

    const onTimeFillInData = spmData?.onTimeInFull
    const fillRateData = spmData?.fillRate
    const onTimeDeliveryData = spmData?.onTimeDelivery
    const tableData = spmData?.vendorData
    const appOwnersList = spmData?.owners
    const isEDFIntegrated = spmData?.edfintegrated;
    const emailList = appOwnersList?.map(contact => contact.emailId).join(', ');

    return (
        <Modal
            // onCloseModal={() => { setDataLoadActionType(""); dispatch(setKeyValue({ key: localStoreKeys.isSpmModalOpened, value: true })); setOpenModal(!openModal) }}
            onCloseModal={handleClose}
            primaryButtonProps={{
                // onClick: () => { setDataLoadActionType(""); dispatch(setKeyValue({ key: localStoreKeys.isSpmModalOpened, value: true })); setOpenModal(!openModal) },
                onClick: handleClose,
                size: "medium",
                text: "Close",
                variant: "primary",
            }}
            showPrimaryButton={true}
            showLink={false}
            showSecondaryButton={false}
            showTertiaryButton={false}
            showAuxiliaryButton={false}
            showSlot={true}
            showModal={openModal}
            closeOnOutsideClick={false}
            hideCloseButton={false}
            type="XL"
          {...getModalAttributes("Supplier Performance"+' '+capability)}
        >
            <div ref={supplierPerformanceRef}>
                <div className="modal-title" style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                    <span>
                        {userData?.FirstName},  the OTIF performance for your suppliers is <b style={{ color: getSPMValuePercentageColor(onTimeFillInData?.onTimeInFullAvg) }}>{onTimeFillInData?.onTimeInFullAvg ? onTimeFillInData?.onTimeInFullAvg + "%" : "-"}</b>
                        {
                            isEDFIntegrated &&
                            <Tooltip direction="bottom" text={staticNotes.EDF_NOTE}>
                                <img src={EDF_checked} alt='image' style={{ width: '18px', height: '22px', marginLeft: "8px", overflow:"visible", marginBottom: "7px" }} />
                            </Tooltip>
                        }
                    </span>
                    {
                        isLoading ? (
                            <></>
                        ) :                    
                        <>
                            {/* <ButtonGroup
                                style={{ marginRight: '2rem' }}
                                className="buy-con-button-group"
                                items={buttonGroupItems}
                                size="small"
                            /> */}
                            
                        
                            <span style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                                <CustomButtons isModal={true} appList={spmData?.apps} />
                                {/* <button onClick={() => handleDomToImgDownloadPdf(supplierPerformanceRef, "Supplier_Performance_Modal")}>PDF</button> */}
                                <span style={{float: 'right', position: 'relative', right: '2rem', bottom: '0.6rem'}}>
                                    <DropdownWithIcons modalRef={supplierPerformanceRef} kpiName={"Supplier_Performance_Modal"} isModal={true} checkPDFDownloaded={checkPDFDownloaded}/>
                                </span>
                            </span>
                        
                        </>
                    }
                </div>
                <div className="modal-update-frequesncy" style={{ marginBottom: "5px", display: "flex", color:"rgb(170, 0, 26)" }}><Icon alt="" icon="info" size="small" /> &nbsp; {staticNotes.SPM_REWORK_NOTE}</div>
                {(spmData?.lastUpdate) && <div className="modal-update-frequesncy">Data As On: {spmData?.lastUpdate} | Refresh Frequency: {spmData?.refreshFrequency}</div>}
                {/* <SupplierModalFilters selectedYear={selectedYear} capability={capability} userData={userDataLandingPage} onParentCallback={getSupplierPerformaceFilters} landingPageFilters={landingPageFilters} setLoader={setLoader} /> */}
                <FilterWithSuppliers selectedYear={selectedYear} appName='Supplier Performance' capability={capability} userData={userDataLandingPage} onParentCallback={getSupplierPerformaceFilters} landingPageFilters={landingPageFilters} setLoader={setLoader} />
                <br />
                {

                        (loader || isLoading) ?
                        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%', height: 300 }}>
                            {/* {console.log(dataLoadActionType !== "SUCCESS_SPM_INHOUSE_ACTION", loader, isLoading)} */}
                            <LoadingSpinner size={{ height: '80px', width: '80px' }} />
                        </div>
                        :
                        <>
                            {console.log("In Else")}
                            <Row gutter={[10, 10]} justify={"start"} style={{ width: "100%" }}>
                                <Col xs={24} sm={24} md={8} lg={8} xl={8}>
                                    <Card style={{ height: '100%' }}>
                                        <div className="spm-chart-title">On-Time In Full</div>
                                        {
                                            onTimeFillInData && onTimeFillInData?.onTimeInFullData && onTimeFillInData?.onTimeInFullData.length > 0 ?
                                                <>
                                                    <div className="spm-chart-value" style={{ color: getSPMValuePercentageColor(onTimeFillInData?.onTimeInFullAvg) }}>{onTimeFillInData?.onTimeInFullAvg ? onTimeFillInData?.onTimeInFullAvg + "%" : "-"}</div>
                                                    <CustomLineChart data={onTimeFillInData?.onTimeInFullData} color="#33ABDA" />
                                                </>
                                                : <NoData />
                                        }
                                    </Card>
                                </Col>
                                <Col xs={24} sm={24} md={8} lg={8} xl={8}>
                                    <Card style={{ height: '100%' }}>
                                        <div className="spm-chart-title">Fill Rate</div>
                                        {
                                            fillRateData && fillRateData?.fillRateData && fillRateData?.fillRateData.length > 0 ?
                                                <>
                                                    <div className="spm-chart-value" style={{ color: getSPMValuePercentageColor(fillRateData?.fillRateAvg) }}>{fillRateData?.fillRateAvg ? fillRateData?.fillRateAvg + "%" : "-"}</div>
                                                    <CustomLineChart data={fillRateData?.fillRateData} color="#33ABDA" />
                                                </>
                                                : <NoData />
                                        }
                                    </Card>
                                </Col>
                                <Col xs={24} sm={24} md={8} lg={8} xl={8}>
                                    <Card style={{ height: '100%' }}>
                                        <div className="spm-chart-title">On-time Delivery</div>
                                        {
                                            onTimeDeliveryData && onTimeDeliveryData?.onTimeDeliveryData && onTimeDeliveryData?.onTimeDeliveryData.length > 0 ?
                                                <>
                                                    <div className="spm-chart-value" style={{ color: getSPMValuePercentageColor(onTimeDeliveryData?.onTimeDeliveryAvg) }}>{onTimeDeliveryData?.onTimeDeliveryAvg ? onTimeDeliveryData?.onTimeDeliveryAvg + "%" : "-"}</div>
                                                    <CustomLineChart data={onTimeDeliveryData?.onTimeDeliveryData} color="#33ABDA" />
                                                </>
                                                : <NoData />
                                        }
                                    </Card>
                                </Col>
                                <br />
                                <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                                    {tableData && tableData.length > 0 ? <SupplierPerfTable data={tableData} /> : <Card style={{ height: '100%' }}><NoData /></Card>}
                                </Col>
                            </Row>
                            <br />
                            <div style={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
                                <div style={{ display: 'flex', alignItems: 'center', backgroundColor: '#0078A7', padding: 10, borderRadius: 5, width: 'fit-content' }}>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                        <path d="M11 7.00195H13V9.00195H11V7.00195ZM11 11.002H13V17.002H11V11.002ZM12 2.00195C6.48 2.00195 2 6.48195 2 12.002C2 17.522 6.48 22.002 12 22.002C17.52 22.002 22 17.522 22 12.002C22 6.48195 17.52 2.00195 12 2.00195ZM12 20.002C7.59 20.002 4 16.412 4 12.002C4 7.59195 7.59 4.00195 12 4.00195C16.41 4.00195 20 7.59195 20 12.002C20 16.412 16.41 20.002 12 20.002Z" fill="white" />
                                    </svg>
                                    <div className="notification-container">
                                        Supplier Performance is calculated at the Sector Level, and users are not able to drill down to the Business Unit (BU) / Market level
                                    </div>
                                </div>
                            </div>


                            <br />
                            <div className="spend-modal-manage-spend" style={{ display: "flex", flexDirection: "column", alignItems: "center", textAlign: "center", width: '100%' }}>
                                <div style={{width: '100%'}}>Please reach out to {appOwnersList?.map((contact, index) => (
                                    <React.Fragment key={index}>
                                        <a href={`mailto:${contact.emailId}`} style={{ color: "#005cbc", textDecoration: "None" }}>{contact.emailId}</a>
                                        {index < appOwnersList.length - 1 && ', '}
                                    </React.Fragment>
                                ))} for any query on the data displayed.</div>
                                <div style={{width: '100%'}}>Please fill in <a href={feedbackFormUrl} target="_blank" style={{ color: "#005cbc", textDecoration: "None" }}>this form</a> for any feedback related to Procurement Hub.</div>
                            </div>
                        </>
                }
                <br/>
            </div>
        </Modal>
    )
}

export default SupplierPerformanceModal